module.exports = __webpack_public_path__ + "static/media/backbone_logo.e2c714b8.png";